











































import Vue from 'vue'
import _ from 'lodash'
import { QcqCommonGridItem } from '@/types'
import { LOAD_COMPETENCE } from '@/store/action-types'
import { Competence } from '@/model/qcq/Competence'

interface ComponentData {
  competencesList: Array<QcqCommonGridItem>
  selectedCompetence: number | null
  validationRules: Array<Function>
  formData: any
  numberOfStars: number | null
  stars: number
  isStar1Disabled: boolean
  isStar2Disabled: boolean
  isStar3Disabled: boolean
  isStar4Disabled: boolean
  isStar5Disabled: boolean
}

export default Vue.extend({
  name: 'AddressRequirementsAgreementDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: String,
    dialogData: {
      type: Object as () => any
    },
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()

    return {
      competencesList: [],
      selectedCompetence: null,
      validationRules: [required],
      formData: {id: null, selectedCompetence: null, quality: null, description: undefined},
      numberOfStars: null,
      stars: 5,
      isStar1Disabled: true,
      isStar2Disabled: true,
      isStar3Disabled: true,
      isStar4Disabled: true,
      isStar5Disabled: true
    }
  },

  computed: {},

  watch: {
    show (newVal: boolean): void {
      if (newVal) {
        const form: any = this.$refs['form']
        if(form) {
          form.resetValidation()
        }
        if(this.dialogData) {
          this.formData = _.cloneDeep(this.dialogData)
        } else {
          this.formData = {id: null, selectedCompetence: null, quality: null, description: undefined}
        }
        this.selectedCompetence = this.formData.selectedCompetence
        this.numberOfStars = this.formData.quality
        this.fetchQuality()
      }

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    }
  },

  methods: {
    resetStars (): void {
      this.isStar1Disabled = true
      this.isStar2Disabled = true
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = null
    },
    star1 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = true
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 1
    },
    star2 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 2
    },
    star3 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 3
    },
    star4 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = false
      this.isStar5Disabled = true
      this.numberOfStars = 4
    },
    star5 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = false
      this.isStar5Disabled = false
      this.numberOfStars = 5
    },

    fetchQuality (): void {
      switch (this.numberOfStars) {
        case null:
          this.resetStars()
          break
        case 1:
          this.star1()
          break
        case 2:
          this.star2()
          break
        case 3:
          this.star3()
          break
        case 4:
          this.star4()
          break
        case 5:
          this.star5()
          break
      }
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        const foundCompetence: any = this.competencesList.find((item: any) => item.id === this.selectedCompetence)
        const payload: any = {
          id: this.formData.id,
          selectedCompetence: this.selectedCompetence,
          quality: this.numberOfStars,
          description: foundCompetence ? foundCompetence.description : ''
        }
        this.$emit('save', payload)
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    }
  },

  async mounted (): Promise<void> {
    this.$store.dispatch(LOAD_COMPETENCE, 1).then((data: Array<Competence>) => {
      data.forEach((item: Competence) => {
        this.competencesList.push(item.commonGridData)
      })
    })
  }
})
